<script lang="ts" context="module">
    export type Tab = { name: string };
</script>

<script lang="ts">
    export let index: number;
    export let tabs: Tab[];
</script>

<!----------------------------------------------------------------------------->

<ul class="tabs" role="tablist">
    {#each tabs as tab, i}
        <li role="tab" class:active={index === i} on:click={() => (index = i)}>
            {tab.name}
        </li>
    {/each}
</ul>

<!----------------------------------------------------------------------------->

<style>
    .tabs {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .tabs li {
        line-height: calc(2.25em - 4px);
        padding: 0 1em;
        user-select: none;
    }

    .tabs li.active {
        border-bottom: 4px solid #753bd8;
    }

    .tabs li:hover {
        background-color: #753bd833;
    }
</style>
